module.exports = __webpack_public_path__ + "img/driver-02.d3151eb7.svg";